function BadgeModalStreak(props) {
    const progressBarWidth = 273;
    let progessBarPct = 0;

    if (props.badge.streak) {
        progessBarPct = props.badge.streak.earned_count >= props.badge.streak.streak_count ? 100 :
            (props.badge.streak.earned_count / props.badge.streak.streak_count) * 100;
    }

    const calcBubblePosition = () => {
        if (props.badge.streak && props.badge.streak.earned_count > 0) {
            if (props.badge.streak.earned_count >= props.badge.streak.streak_count) {
                return progressBarWidth - 3; // 3px bubble margin
            } else {
                return ((props.badge.streak.earned_count / props.badge.streak.streak_count) * progressBarWidth) - 3; // 3px bubble margin
            }
        } else {
            return 0;
        }
    };

    const renderDots = () => {
        switch (props.badge.streak.streak_count) {
            case 1:
                return <>
                    <div className={`dot ${props.badge.streak.earned_count >= 1 && 'unlocked'}`}>1</div>
                </>;

            case 2:
                return <>
                    <div className={`dot ${props.badge.streak.earned_count >= 1 ? 'unlocked' : ''}`}>1</div>
                    <div className={`dot-connect ${props.badge.streak.earned_count >= 2 ? 'unlocked' : ''}`}></div>
                    <div className={`dot ${props.badge.streak.earned_count >= 2 ? 'unlocked' : ''}`}>2</div>
                </>;

            case 3:
                return <>
                    <div className={`dot ${props.badge.streak.earned_count >= 1 ? 'unlocked' : ''}`}>1</div>
                    <div className={`dot-connect ${props.badge.streak.earned_count >= 2 ? 'unlocked' : ''}`}></div>
                    <div className={`dot ${props.badge.streak.earned_count >= 2 ? 'unlocked' : ''}`}>2</div>
                    <div className={`dot-connect ${props.badge.streak.earned_count >= 3 ? 'unlocked' : ''}`}></div>
                    <div className={`dot ${props.badge.streak.earned_count >= 3 ? 'unlocked' : ''}`}>3</div>
                </>;

            default:
                return <></>;
        }
    };

    return (
        <div className="badge-modal-streak-progress">
            {props.badge.streak.streak_count > 3 && !props.badge.streak.hide_progress ?
                <div className="badge-modal-streak-progress-bar-area">
                    {props.badge.streak.earned_count !== 0 && <div className="earned-bubble-container">
                        <div className="earned" style={{ marginLeft: `${calcBubblePosition()}px` }}>
                            <div className={`bubble ${props.badge.streak.earned_count > 0 ? 'green' : ''}`}>
                                { props.badge.streak.earned_count >= props.badge.streak.streak_count ?
                                    props.badge.streak.streak_count : props.badge.streak.earned_count }
                            </div>
                            <div className={`triangle ${props.badge.streak.earned_count > 0 ? 'green' : ''}`}></div>
                        </div>
                    </div>}
                    <div className="badge-modal-streak-progress-bar-container">
                        <div className={`limit ${props.badge.streak.streak_count === 0 ? 'green' : ''}`}>0</div>
                        <div className="badge-modal-streak-progress-bar" style={{ width: `${progressBarWidth}px` }}>
                            <div className="inner" style={{ width: `${progessBarPct}%` }}></div>
                        </div>
                        <div className="limit">{props.badge.streak.streak_count}</div>
                    </div>
                </div>
                :
                <div className="badge-modal-streak-progress-dots">
                    {renderDots()}
                </div>
            }
        </div>
    );
}

export default BadgeModalStreak;